import { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { GridContext } from "./GridContext/GridContext";
import { gridKeikkas_isSame } from "src/pages/Grid/GridKeikka/gridKeikkaFunctions";

const GridKeikkaEditorContext = createContext();

export const GridKeikkaEditorProvider = ({ children }) => {
  const { gridKeikka, gridKeikkaEditorIsOpen, setGridKeikkaEditorIsOpen } =
    useContext(GridContext) || {};
  const [origKeikka, setOrigKeikka] = useState(null);

  const hasChanged = () => {
    if (!origKeikka) return false;
    const isSame = gridKeikkas_isSame(gridKeikka, origKeikka);
    return !isSame;
  };

  return (
    <GridKeikkaEditorContext.Provider
      value={{
        origKeikka,
        setOrigKeikka,
        hasChanged,
        gridKeikkaEditorIsOpen,
        setGridKeikkaEditorIsOpen,
      }}>
      {children}
    </GridKeikkaEditorContext.Provider>
  );
};

export const useGridKeikkaEditor = () => useContext(GridKeikkaEditorContext);

GridKeikkaEditorProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
